import { __assign } from 'tslib';
import React__default, { useState, useLayoutEffect } from 'react';
import { Box, Paper, Skeleton, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import DefaultIcon from '../../DefaultIcon/index.js';

var DummyCard = function DummyCard(_a) {
    var className = _a.className, _b = _a.testId, testId = _b === void 0 ? "KFThumbnailGeneratorDummyCard" : _b, sx = _a.sx, width = _a.width, height = _a.height, image = _a.image, name = _a.name, format = _a.format, iconName = _a.iconName, actionsComponent = _a.actionsComponent, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c, loading = _a.loading, _d = _a.shared, shared = _d === void 0 ? false : _d;
    var t = useTranslation("refront-components").t;
    var _e = useState(), imageLoaded = _e[0], setImageLoaded = _e[1];
    // reset image loaded state only when the image to be loaded is different than the one already loaded:
    useLayoutEffect(function () {
        if (image && imageLoaded !== image) {
            setImageLoaded(undefined);
        }
    }, [image, imageLoaded]);
    return (React__default.createElement(Box, { className: clsx("KFThumbnailGeneratorDummyCard", className), "data-testid": testId, sx: __assign(__assign({}, sx), { position: "relative" }) }, width && height && (React__default.createElement(Paper, { elevation: 1, variant: "elevation", sx: {
            display: "grid",
            alignContent: "flex-start",
            alignItems: "center",
            gridTemplateAreas: "\"title\" \"actions\" \"preview\"",
            gridTemplateColumns: "1fr",
            gridTemplateRows: "1fr 1fr 19rem",
            padding: function (theme) { return theme.spacing(1); },
            width: "100%"
        } },
        React__default.createElement(Box, { sx: { gridArea: "title", overflow: "hidden" } },
            React__default.createElement(Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                } },
                React__default.createElement(Box, null, loading ? (React__default.createElement(Skeleton, { variant: "circular", animation: false, width: 30, height: 30 })) : (React__default.createElement(KIcon, { sx: {
                        fontSize: "2em"
                    }, className: "fa-regular ".concat(iconName || "fa-file-image") }))),
                React__default.createElement(Box, { sx: { flexGrow: "1", overflow: "hidden" } },
                    React__default.createElement(Typography, { variant: "h6", sx: {
                            lineHeight: "normal",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            maxWidth: "100%"
                        }, title: name }, loading ? React__default.createElement(Skeleton, { animation: false, width: 300 }) : name),
                    React__default.createElement(Typography, { variant: "caption", sx: {
                            color: function (theme) { return theme.palette.grey[600]; }
                        } }, loading ? (React__default.createElement(Skeleton, { animation: false, width: 300 })) : ("".concat(width, "x").concat(height, "px - ").concat(format || "")))),
                React__default.createElement(Box, { sx: { alignSelf: "flex-start" } }, !loading && !shared && (React__default.createElement(KIcon, { title: t("components.kf-thumbnail-generator.prewiew.user.icon.title"), sx: {
                        fontSize: "1em"
                    }, className: "fa-regular fa-user" }))))),
        actionsComponent && (React__default.createElement(Box, { sx: {
                gridArea: "actions",
                gap: 0.8,
                display: "flex",
                justifyContent: "flex-end"
            } }, actionsComponent)),
        React__default.createElement(Box
        // START WARNING
        // we add a key here in order to force the child component (LazyLoadImage)
        // to unmount if the image changes: this allows the child component to be unmounted
        // and return to lazyload mode otherwise the image remains in the DOM and the lazy
        // no longer works on images that are no longer in viewport and behaves like eager loading
        , { 
            // START WARNING
            // we add a key here in order to force the child component (LazyLoadImage)
            // to unmount if the image changes: this allows the child component to be unmounted
            // and return to lazyload mode otherwise the image remains in the DOM and the lazy
            // no longer works on images that are no longer in viewport and behaves like eager loading
            key: image, 
            // END WARNING
            sx: {
                gridArea: "preview",
                justifySelf: "center",
                width: "100%",
                height: "100%",
                backgroundColor: function (theme) { return theme.palette.grey[200]; },
                borderRadius: "5px"
            } }, !loading && (React__default.createElement(LazyLoadImage, { delayMethod: "debounce", delayTime: 800, onLoad: function () { return setImageLoaded(image); }, alt: name, width: "100%", height: "100%", src: image, style: {
                objectFit: "scale-down",
                // instead of loading the css file from the lib (react-lazy-load-image-component/src/effects/opacity.css) to manage opacityEffect, we manage it directly:
                transition: "opacity .3s",
                opacity: imageLoaded ? 1 : 0
            } })))))));
};

export { DummyCard as default };
//# sourceMappingURL=index.js.map
